// helpers per le funzioni crittografiche. Utilizzato per lo più da
// EncryptionService
import forge from "node-forge";
import { getKeyInfo } from "./TemplateHelpersNewAlg";
const BigInteger = forge.jsbn.BigInteger;
const secureRandom = require("secure-random");

function getKeyLength(key) {
  return getByteLength(key.n);
}
function getByteLength(b) {
  let n = b.bitLength();
  return (n + 7) >> 3;
}

function sha1Digest(input) {
  var md = forge.md.sha1.create();
  md.update(input);
  return md;
}
function sha256Digest(input) {
  var md = forge.md.sha256.create();
  md.update(input);
  return md;
}
function encodeASN1(signedInfo, publicKey) {
  let keyLength;
  if (!publicKey) keyLength = 128;
  // default key size 1024 b
  else {
    keyLength = getKeyLength(publicKey);
  }
  let digest = sha1Digest(signedInfo)
    .digest()
    .toHex();
  digest = "3021300906052b0e03021a05000414" + digest; // sha1 OID
  let hex = "0001"; // block type 1 for private key operations
  while (hex.length + digest.length < keyLength * 2 - 2) {
    hex += "ff"; // padding with ff bytes
  }

  hex += "00";
  hex += digest;
  return hex;
}
function encodeASN256(signedInfo, publicKey) {
  let keyLength;
  if (!publicKey) keyLength = 128;
  // default key size 1024
  else {
    keyLength = getKeyLength(publicKey);
  }
  let digest = sha256Digest(signedInfo)
    .digest()
    .toHex();
  digest = "3031300d060960864801650304020105000420" + digest; // sha256 OID
  let hex = "0001"; // block type 1 for private key operations
  while (hex.length + digest.length < keyLength * 2 - 2) {
    hex += "ff"; // padding with ff bytes
  }

  hex += "00";
  hex += digest;
  return hex;
}
function getCertificateSHA256(cert) {
  const der = forge.asn1.toDer(forge.pki.certificateToAsn1(cert)).getBytes();
  const m = forge.md.sha256.create();
  m.start();
  m.update(der);
  const fingerprint = m.digest().getBytes();
  return forge.util.encode64(fingerprint);
}
function getIssuerName(cert) {
  const issuerName =
    "CN=" +
    cert.issuer.getField("CN").value +
    ",OU=" +
    cert.issuer.getField("OU").value +
    ",O=" +
    cert.issuer.getField("O").value +
    ",L=,ST=" +
    cert.issuer.getField("ST").value +
    ",C=" +
    cert.issuer.getField("C").value;
  return issuerName;
}
export {
  getByteLength,
  sha1Digest,
  sha256Digest,
  encodeASN1,
  encodeASN256,
  getCertificateSHA256,
  getIssuerName
};
